"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getCurrentStoreData = function getCurrentStoreData(store) {
  var storeDataArray = store === null || store === void 0 ? void 0 : store.map(function (storeItem) {
    return {
      action: storeItem.action,
      state: storeItem.state,
      features: storeItem.features
    };
  });
  return storeDataArray;
};

var _default = getCurrentStoreData;
exports["default"] = _default;
module.exports = exports.default;